export const POLICIES_BASE_URL = "/policies";
export const PRIVACY_POLICY_URL = POLICIES_BASE_URL + "/privacy";